export enum RoleEnum {
    'Super Admin' = 1,
    'Company Admin' = 2,
    'User' = 3
}